import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const tierraVerdeConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Tierra Verde Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Tierra Verde, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_tierra_verde',

   /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Tierra Verde',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Tierra Verde Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring expert tree care to the 
     island community of <strong>Tierra Verde</strong>. Situated between Tampa 
     Bay and the Gulf of Mexico, this upscale island neighborhood faces unique 
     tree challenges constant water exposure on multiple sides, strong tidal 
     winds, and storm tracks that hit hard. Mature trees that overhang waterfront 
     homes and docks need regular professional attention to stay safe.`,

    `We specialize in <strong>dangerous tree removal and precision trimming on 
     island and waterfront properties</strong> salt-damaged canopies, storm split 
     limbs near luxury homes, palms leaning over docks and seawalls, and large 
     tree removals on tight residential lots where access and care are critical. 
     We protect your property throughout every phase of the job.`,

    `<strong>Sam's Tree Service</strong> delivers reliable, professional tree care 
     throughout <strong>Tierra Verde</strong> and the surrounding 
     <strong>South Pinellas waterfront</strong> communities keeping your island 
     property safe, beautiful, and storm-ready all year long.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Tierra Verde, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_TierraVerde = () => <LocationPage config={tierraVerdeConfig} />;
export default Services_TierraVerde;
